import {URL} from './api';
import axios from 'axios';
import {parseStorage} from './functions'

import {helpBarAction} from './helpbarAction'

export const GET_GUIDE = 'GET_GUIDE'
export const GET_GUIDE_DETAIL = 'GET_GUIDE_DETAIL'
export const GET_GUIDE_READ = 'GET_GUIDE_READ'
export const GUIDE_DETAIL_RESET = 'GUIDE_DETAIL_RESET'
export const GUIDE_READ_RESET = 'GUIDE_READ_RESET'


export function getGuide(){
    return dispatch => {
        axios.get(URL + `/guest/guide`,{
            headers: {
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(function(res){
            dispatch({
                type: GET_GUIDE,
                data: res.data.results.data
            })
        }).catch(function(err){
            
        })
    }
}

export function getGuideDetail(name){
    return dispatch => {
        axios.get(URL + `/guest/guide/${name}/detail`,{
            headers: {
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(function(res){
            dispatch({
                type: GET_GUIDE_DETAIL,
                data: res.data.results
            })
        }).catch(function(err){
            
        })
    }
}

export function getGuideRead(name, slug){
    return dispatch => {
        // axios.get(URL + `/guest/guide/${name}/${slug}`,{
        axios.get(URL + `/guest/guide/${slug}`,{
            headers: {
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(function(res){
            dispatch({
                type: GET_GUIDE_READ,
                data: res.data.results
            })
        }).catch(function(err){
            
        })
    }
}

export function guideUpdate(id, data){    
    return dispatch => {
        dispatch({type: 'HELPBAR_RESET'})
        const auth = new parseStorage();        
        axios.post(URL + `/admin/guide/${id}/update`, data, {
            headers: {
                'Authorization' : 'Bearer ' + auth.token,
                'Accept' : 'application/json'
            },     
        }).then(res => {                        
            dispatch(helpBarAction({
                messages: 'update article success',
                className: 'bg-green'
            }))
        }).catch(err => {            
            dispatch(helpBarAction({
                messages: 'harap lengkapi profile data terlebih dahulu'
            }))
        })        
    }
}


// WEBPACK FOOTER //
// ./src/actions/guideAction.js